import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "home__message" }, [
  /*#__PURE__*/_createTextVNode(" Hello."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" my name is "),
  /*#__PURE__*/_createElementVNode("span", { class: "home--stronger" }, "Joey Leger"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" and I'm a full-stack engineer. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "home__line" }, null, -1)
const _hoisted_4 = { class: "home__skills" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" I am a full-stack engineer by trade who lives just outside of "),
  /*#__PURE__*/_createElementVNode("span", { class: "home--stronger" }, "Charlotte, North Carolina"),
  /*#__PURE__*/_createTextVNode(" and I'm passionate about technology - not a specific framework or language. In this line of work it's about adaptation, and what works best for the project. I'm open to learning any stack if it works. I want to be the best developer ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("I believe in shipping quality, "),
  /*#__PURE__*/_createElementVNode("em", null, "testable"),
  /*#__PURE__*/_createTextVNode(" code and working in flow.")
], -1)
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Badge = _resolveComponent("Badge")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_router_link, {
      to: "/projects",
      custom: ""
    }, {
      default: _withCtx(({ navigate }) => [
        _createVNode(_component_Button, {
          onClick: navigate,
          class: "home__btn",
          role: "link"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Check Out My Work →")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("p", null, [
        _createTextVNode(" I love both sides of full-stack development. The front-end scratches my creative itch, especially when it comes to UI/UX and building mobile-first experiences. I also enjoy all things Javascript and using libraries such as "),
        _createVNode(_component_Badge, null, {
          default: _withCtx(() => [
            _createTextVNode("React")
          ]),
          _: 1
        }),
        _createTextVNode(", and "),
        _createVNode(_component_Badge, null, {
          default: _withCtx(() => [
            _createTextVNode("Vue")
          ]),
          _: 1
        }),
        _createTextVNode(". With the back-end side I enjoy working with "),
        _createVNode(_component_Badge, null, {
          default: _withCtx(() => [
            _createTextVNode("Node")
          ]),
          _: 1
        }),
        _createTextVNode(", "),
        _createVNode(_component_Badge, null, {
          default: _withCtx(() => [
            _createTextVNode("C#")
          ]),
          _: 1
        }),
        _createTextVNode(" and "),
        _createVNode(_component_Badge, null, {
          default: _withCtx(() => [
            _createTextVNode("Python")
          ]),
          _: 1
        }),
        _createTextVNode(" creating API's and working with databases such as "),
        _createVNode(_component_Badge, null, {
          default: _withCtx(() => [
            _createTextVNode("SQL")
          ]),
          _: 1
        }),
        _createTextVNode(", "),
        _createVNode(_component_Badge, null, {
          default: _withCtx(() => [
            _createTextVNode("ElasticSearch")
          ]),
          _: 1
        }),
        _createTextVNode(" and "),
        _createVNode(_component_Badge, null, {
          default: _withCtx(() => [
            _createTextVNode("Redis")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("img", {
      alt: "laptop computer on table",
      class: "home__image",
      src: _ctx.mobile ? require(`@/assets/images/stock__computer-mobile.jpg`) : require(`@/assets/images/stock__computer.jpg`)
    }, null, 8, _hoisted_7)
  ]))
}